/* Clandestino — scroll reveal genérico para todas las páginas.
   Aplica fade + slide-up a bloques de contenido comunes al entrar en viewport. */
(function () {
  var SELECTORS = [
    '.cl-section-heading', '.cl-hero__grid > div', '.cl-hero__art',
    '.cl-whatwedo__card', '.cl-values__card', '.cl-process__step',
    '.cl-product-card', '.cl-project-card', '.cl-history__row',
    '.cl-history__quote', '.cl-history__gallery-wrap', '.cl-bts__grid > *',
    '.cl-bts__cell', '.cl-mfmaterial__grid > *', '.cl-mftech__hero-grid > *',
    '.cl-mftech__app-media', '.cl-envdata__block', '.cl-envdata__hero',
    '.cl-b2b__stat', '.cl-b2b__product-card', '.cl-impact__stat',
    '.cl-b2bhero__inner > *', '.cl-b2bhero__thumb',
    '.cl-b2bwhat__media', '.cl-b2bwhat__content', '.cl-b2bwhat__stat',
    '.cl-b2b__report--split > *', '.cl-b2bcta__text', '.cl-b2bcta__media',
    '.cl-mfcolors__media', '.cl-mfcolors__content',
    '.cl-mftech__specs-list li', '.cl-mftech__app-card', '.cl-mftech__thickness-card',
    '.cl-contact__form-wrap', '.cl-contact__aside', '.cl-faq__item',
    '.cl-about-intro__media', '.cl-mftech__cert-intro', '.cl-mftech__cert-photo',
    '.cl-mftech__cert-hero', '.cl-mftech__cert-card2'
  ].join(',');

  function init() {
    var els = document.querySelectorAll(SELECTORS);
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cl-reveal-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          var el = entry.target;
          setTimeout(function () { el.classList.add('cl-reveal-visible'); }, (i % 4) * 70);
          io.unobserve(el);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });

    els.forEach(function (el) {
      el.classList.add('cl-reveal');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

  /* Acordeones (<details class="cl-accordion">) con animación suave de alto + fade,
     en vez del toggle instantáneo por defecto del navegador. */
  function initAccordions(scope) {
    (scope || document).querySelectorAll('details.cl-accordion').forEach(function (details) {
      if (details.dataset.clAnim) return;
      details.dataset.clAnim = '1';
      var content = details.querySelector('.cl-accordion__content');
      var summary = details.querySelector('summary');
      if (!content || !summary) return;
      content.style.overflow = 'hidden';

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (details.classList.contains('cl-is-animating')) return;
        details.classList.add('cl-is-animating');

        if (!details.open) {
          details.open = true;
          var target = content.scrollHeight;
          content.style.height = '0px';
          content.style.opacity = '0';
          content.style.transition = 'none';
          requestAnimationFrame(function () {
            content.style.transition = 'height .32s ease, opacity .32s ease';
            requestAnimationFrame(function () {
              content.style.height = target + 'px';
              content.style.opacity = '1';
            });
          });
          content.addEventListener('transitionend', function done(ev) {
            if (ev.propertyName !== 'height') return;
            content.style.height = '';
            content.style.transition = '';
            details.classList.remove('cl-is-animating');
            content.removeEventListener('transitionend', done);
          });
        } else {
          var current = content.scrollHeight;
          content.style.height = current + 'px';
          content.style.opacity = '1';
          content.style.transition = 'none';
          requestAnimationFrame(function () {
            content.style.transition = 'height .28s ease, opacity .28s ease';
            requestAnimationFrame(function () {
              content.style.height = '0px';
              content.style.opacity = '0';
            });
          });
          content.addEventListener('transitionend', function done(ev) {
            if (ev.propertyName !== 'height') return;
            details.open = false;
            content.style.height = '';
            content.style.opacity = '';
            content.style.transition = '';
            details.classList.remove('cl-is-animating');
            content.removeEventListener('transitionend', done);
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAccordions(); });
  } else {
    initAccordions();
  }
  document.addEventListener('shopify:section:load', function (e) { initAccordions(e.target); });
})();
